import { FormControlLabel, Switch, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const SharedMediaSwitch = ({ shared, onChange }) => {
  const { t } = useTranslation();

  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            checked={shared}
            onChange={(event) => onChange(event.target.checked)}
            color="primary"
          />
        }
        label={t("media.shared")}
      />
      <Typography variant="caption" color="text.secondary" display="block">
        {shared ? t("media.sharedHint") : t("media.exclusiveHint")}
      </Typography>
    </div>
  );
};

export default SharedMediaSwitch;
